import React from 'react';
import { Layout, Row, Col, Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import {
  Bluish,
  WhiteFour,
  WhiteThree,
  BrownishGrey,
  WarmGrey
} from '../../styles/Colours';
import { Container } from '../../styles/BaseStyles';
import CookiesPopup from './CookiesPopup';
import { device } from '../../styles/Responsive';
import { FooterText } from '../layout/FooterText';

const ContactSection = styled.div`
  background: ${Bluish};
  padding: 70px 0;

  @media ${device.tablet} {
    display: none;
  }
`;

const Title = styled.div`
  font-size: 40px;
  font-weight: bold;
  color: ${WhiteFour};
  display: flex;
`;

const Link = styled.div`
  margin-top: 20px;
  font-size: 14px;
  font-weight: 500;
  color: ${WhiteFour};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;

  i {
    font-size: 30px;
    margin-left: 20px;
  }
`;

const Footer = styled.div`
  background: ${WhiteThree};
  padding: 35px 0;
`;

const Copyright = styled.div`
  float: left;
  font-size: 10px;
  font-weight: 500;
  color: ${BrownishGrey};
  text-transform: uppercase;
  margin-top: 13px;

  a,
  a:hover,
  a:focus,
  a:active {
    color: ${BrownishGrey};
  }

  @media ${device.mobileL} {
    font-size: 8px;
    width: 100%;
  }
`;

const ShareIcon = styled.div`
  padding: 5px;
  float: right;
  color: ${WarmGrey};
  cursor: pointer;
  font-size: 20px;
  margin-left: 10px;

  @media ${device.mobileL} {
    font-size: 18px;
    margin-left: 10px;
    margin-top: 10px;
  }
`;

let FooterComponent = ({ location, history, hideContact, contact }) => {
  const hideSection =
    hideContact ||
    (location.pathname && location.pathname.indexOf('/contact') > -1) ||
    (location.pathname && location.pathname.indexOf('/webinar') > -1) ||
    (location.pathname && location.pathname.indexOf('/events/') > -1);
  return (
    <Layout>
      {!hideSection && (
        <ContactSection>
          <Container>
            <Row align="middle" justify="center">
              <Col span={12}>
                <Title>Any questions?</Title>
              </Col>
              <Col span={12}>
                <Link onClick={() => history.push('/contact')}>
                  <span>Contact Us</span>
                  <Icon type="arrow-right" theme="outlined" />
                </Link>
              </Col>
            </Row>
          </Container>
        </ContactSection>
      )}

      <Footer>
        <Container>
          <Copyright>
            <FooterText />
          </Copyright>
          <ShareIcon onClick={() => window.open(contact.twitter, '_blank')}>
            <Icon type="twitter" theme="outlined" />
          </ShareIcon>
          <ShareIcon
            bottom="70px"
            onClick={() => window.open(contact.facebook, '_blank')}
          >
            <Icon type="facebook" theme="filled" />
          </ShareIcon>
          <ShareIcon
            bottom="70px"
            onClick={() => window.open(contact.instagram, '_blank')}
          >
            <Icon type="instagram" theme="filled" />
          </ShareIcon>
        </Container>
      </Footer>
      <CookiesPopup history={history} />
    </Layout>
  );
};

const mapStateToProps = (state, ownProps) => ({
  contact: state.info.contact
});

export default withRouter(connect(mapStateToProps)(FooterComponent));



// WEBPACK FOOTER //
// ./src/pages/layout/FooterComponent.js